import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openDrawer } from "../../../redux/slices/menu/menuSlice";
import useResponsive from "../../../hooks/useResponsive";
import DrawerHeader from "./DrawerHeader";
import DrawerContent from "./DrawerContent";

function Drawer({ menuItems }) {
  const dispatch = useDispatch();
  const drawerOpen = useSelector((s) => s.menu.drawerOpen);
  const { isDesktop } = useResponsive();

  useEffect(() => {
    dispatch(openDrawer({ drawerOpen: isDesktop }));
  }, [isDesktop, dispatch]);

  if (!isDesktop) {
    return (
      <>
        {drawerOpen && (
          <div
            onClick={() => dispatch(openDrawer({ drawerOpen: false }))}
            style={{ ...styles.backdrop, zIndex: 1100 }}
          />
        )}
        <aside
          style={{
            ...styles.overlay,
            backgroundColor: "#1677ff",
            borderColor: "rgba(255,255,255,0.2)",
            transform: drawerOpen ? "translateX(0)" : "translateX(-100%)",
          }}
        >
          <DrawerHeader />
          <DrawerContent menuItems={menuItems} />
        </aside>
      </>
    );
  }

  return (
    <aside
      style={{
        ...styles.desktop,
        backgroundColor: "#1677ff",
        borderColor: "rgba(255,255,255,0.2)",
        width: drawerOpen ? 260 : 0,
        borderRightWidth: drawerOpen ? 1 : 0,
        transition: "width 0.3s ease, border-right-width 0.3s ease",
      }}
    >
      <DrawerHeader />
      <DrawerContent menuItems={menuItems} />
    </aside>
  );
}

const styles = {
  desktop: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    borderRight: "1px solid",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    zIndex: 50,
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: 280,
    height: "100vh",
    borderRight: "1px solid",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    zIndex: 1200,
    transition: "transform 0.3s ease",
  },
  backdrop: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
  },
};

export default Drawer;
